<template>
    <div class="row">
        <div class="col-12">
            <card>
                <template slot="header">
                    <el-form label-width="200px" :label-position="$store.state.props.isMobile ? 'top' : 'right'">
                        <el-form-item label="E-Mails">
                            <el-input
                                v-model="emails"
                                type="textarea"
                                rows="5"
                                class="mb-3"/>
                            <p>Comma separated list of users who can access event</p>
                        </el-form-item>
                    </el-form>
                    <div class="d-flex justify-content-end">
                        <el-button
                            type="primary"
                            class="btn btn-primary"
                            :loading="inviting"
                            @click="submit">
                                Invite
                        </el-button>
                    </div>
                </template>
            </card>
        </div>
    </div>
</template>

<script>
import http from '../../http'

export default {
    data () {
        return {
            emails: '',
            inviting: false
        }
    },
    methods: {
        submit: async function () {
            this.inviting = true
            try {
                await http.post('/api/users/invite', {
                    eventId: this.$route.params.eventId,
                    emails: this.emails
                })
                this.$notify('Invitations were successfully sent!')
                this.emails = ''
                this.$router.push({ name: 'users' })
            } catch (e) {
                console.log(e)
                console.log('erorr inviting users')
                this.$store.dispatch('handleErrors', e)
            }
            this.inviting = false
        }
    }
}
</script>